import { useEffect, useState } from 'react';
import { Input } from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { X } from 'lucide-react';
import api from '../../../lib/api';

// Buscador de contactos Alegra (cliente / contraparte) por nombre o RUT.
export function ContactoSearch({ value, onChange, testid = 'contacto' }) {
  const [q, setQ] = useState('');
  const [opts, setOpts] = useState([]);

  useEffect(() => {
    if (value || q.trim().length < 2) { setOpts([]); return undefined; }
    const t = setTimeout(async () => {
      try {
        const r = await api.get('/conciliacion-bancaria/proveedores-alegra', { params: { q: q.trim() } });
        setOpts(r.data.proveedores || []);
      } catch { setOpts([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, value]);

  if (value) {
    return (
      <div className="flex items-center justify-between rounded-md border bg-emerald-50 px-2 py-1.5 text-sm" data-testid={`${testid}-seleccionado`}>
        <span className="truncate"><b>{value.nombre}</b> <span className="font-mono text-xs text-muted-foreground">{value.identificacion}</span></span>
        <Button size="sm" variant="ghost" className="h-6 w-6 p-0" onClick={() => onChange(null)} data-testid={`${testid}-quitar`}><X className="h-3.5 w-3.5" /></Button>
      </div>
    );
  }
  return (
    <div className="relative">
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nombre o RUT…" className="text-sm" data-testid={`${testid}-input`} />
      {opts.length > 0 && (
        <div className="absolute z-20 mt-1 max-h-48 w-full overflow-y-auto rounded-md border bg-white shadow-md" data-testid={`${testid}-opciones`}>
          {opts.map((o) => (
            <button key={o.alegra_id} type="button" onClick={() => { onChange(o); setQ(''); setOpts([]); }}
              className="flex w-full items-center justify-between px-2 py-1.5 text-left text-xs hover:bg-slate-50" data-testid={`${testid}-opcion-${o.alegra_id}`}>
              <span className="truncate">{o.nombre}</span><span className="ml-2 font-mono text-muted-foreground">{o.identificacion}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
